import React from 'react';
import Reflux from 'reflux';
import EventFolderListStore from 'flux/stores/EventFolderListStore';
import FolderBreadcrumb from 'shared/components/event/folderBreadcrumb';
import RouteActions from 'flux/actions/RouteActions';
import EventFolderListActions from 'flux/actions/EventFolderListActions';

/**
 * Event Folder Breadcrumb
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connectFilter(EventFolderListStore, 'breadCrumb', (st) =>
      st.get('parentPath'),
    ),
  ],

  displayName: 'EventFolderListBreadcrumb',

  render() {
    let crumb = this.state.breadCrumb;

    let { teamId, eventId } = this.props;

    return (
      <FolderBreadcrumb
        breadCrumb={crumb}
        onBreadcrumbClick={(parentPath, part) =>
          EventFolderListActions.setFolderPath(parentPath, part)
        }
        onRootClick={() => RouteActions.goToEvent({ teamId, eventId })}
      />
    );
  },
});
